// Chakra imports
import {
  Box,
  Button,
  Flex,
  useColorMode,
  useColorModeValue,
  Text,
  Spinner,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import PieChart from "components/charts/PieChart";
import Menu from "components/menu/MainMenu";
// Assets
import { pieChartOptions } from "variables/charts";
import { useState } from "react";
import { ModalCTR } from "./CTRModal";
import { UseDashboard } from "hooks/DashboardHook";
import { useQuery } from "react-query";

interface VersionsCardProps {
  [x: string]: any;
  name: string;
}

export default function CTRCard(props: VersionsCardProps) {
  const [filter, setFilter] = useState<number>(6);
  const [versionSelect, setVersionSelect] = useState<number>();
  const [CTRname, setCTRname] = useState<string>("");
  const [CTRLucroReal, setCTRLucroReal] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { name, ...rest } = props;
  const theme = useColorMode();
  const themeSelect = theme.colorMode;

  const { findCRTsGraphic } = UseDashboard();
  const { data, isLoading, error } = useQuery(
    ["findCRTsGraphic", name, filter],
    () => findCRTsGraphic(filter)
  );

  // Chakra Color Mode
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  return (
    <Card
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      w="100%"
      mb="0px"
      {...rest}
    >
      <Flex
        align="center"
        justify="space-between"
        textAlign="center"
        w="100%"
        pe="20px"
        pt="5px"
      >
        <Button
          bg={boxBg}
          fontSize="sm"
          fontWeight="500"
          color={textColorSecondary}
          borderRadius="7px"
        >
          {name}
        </Button>

        <Menu onFilterSelected={(data: any) => setFilter(data)} />
      </Flex>
      <Flex h={"100%"} w="100%" flexDirection={{ base: "column", lg: "column" }}>
        <Box minH="100%" minW="100%" mt="auto">
          {isLoading ? (
            <Flex alignItems={"center"} justify={"center"} w="full" h={"full"}>
              <Spinner w={32} h={32} />
            </Flex>
          ) : error ? (
            <Flex
              width={"100%"}
              height={"100%"}
              justify={"center"}
              align={"center"}
            >
              <Text align="center">{String(error || "")}</Text>
            </Flex>
          ) : data.length === 0 ? (
            <Flex
              width={"100%"}
              height={"100%"}
              justify={"center"}
              align={"center"}
            >
              <Text align="center" fontSize={"xl"} fontWeight={"bold"}>
                Nenhum dado encontrado
              </Text>
            </Flex>
          ) : (
            <PieChart
              key={themeSelect + filter + data}
              chartData={data.map((item) => item.QUANTIDADE)}
              chartOptions={{
                labels: data.map((item) => item.REGIME_TRIBUTARIO),
                theme: {
                  mode: themeSelect,
                },
                chart: {
                  width: "50px",
                  background: "transparent",
                  events: {
                    legendClick: function (
                      event: any,
                      index: any,
                      config: any
                    ) {
                      setVersionSelect(data[index].ID_REGIME);
                      setCTRname(data[index].REGIME_TRIBUTARIO);
                      setCTRLucroReal(data[index].LUCRO_REAL);
                      setOpenModal(true);
                    },
                  },
                },
                ...pieChartOptions,
              }}
            />
          )}
        </Box>
        {openModal ? (
          <ModalCTR
            idCTR={versionSelect}
            lucroReal={CTRLucroReal}
            dias={filter}
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            nomeCTR={CTRname}
          />
        ) : null}
      </Flex>
    </Card>
  );
}
